/*@flow*/
import { createContext } from 'react';
import * as I from 'immutable';

type T = I.List<*>;
export const StackContext: React$Context<T> = createContext<T>(I.List());
